import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, palette }) => ({
  root: {
    minHeight: 400,
    pointerEvents: ({ isLoading }) => isLoading ? 'none' : 'initial'
  },
  leftBar: {
    borderRadius: spacing(0, 2, 2, 0),
    width: spacing(2),
    backgroundColor: ({ enabled }) => enabled ? palette.primary.light : palette.grey.dark
  },
  paper: {
    padding: spacing(0, 6)
  },
  suscription: {
    color: ({ suscribed }) => suscribed ? palette.primary.light : palette.grey.dark
  },
  role: {
    textTransform: 'capitalize'
  },
  loadingAnimation: {
    minHeight: 400
  }
}))
